import { AfterViewInit, Component, Inject, NgZone, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { I18N_CONFIG, MasterStoreKey } from '@conf';
import {
  AswCommonStoreService,
  AswContextStoreService,
  ErrorsHandlerService,
  PageLoadingService,
  SystemDateService,
} from '@lib/services';
import { Observable, Subscription, take } from 'rxjs';
import { SampleSubHeaderComponent } from './sub-header/sample-sub-header/sample-sub-header.component';
import { environment } from '@env/environment';
import { DOCUMENT } from '@angular/common';
import { CheckinFunctionIdType, CheckinPageIdType } from '@common/interface';
import { CheckinSearchSubHeaderComponent as CheckinSearchSubHeaderComponent } from './sub-header/checkin-search-sub-header/checkin-search-sub-header.component';
import { CheckinMybookingSubHeaderComponent } from './sub-header/checkin-mybooking-sub-header/checkin-mybooking-sub-header.component';
import { CheckinSelectSubHeaderComponent } from './sub-header/checkin-select-sub-header/checkin-select-sub-header.component';
import { CheckinCompletedSubHeaderComponent } from './sub-header/checkin-completed-sub-header/checkin-completed-sub-header.component';
import { CheckinPassengerInputSubHeaderComponent } from './sub-header/checkin-passenger-input-sub-header/checkin-passenger-input-sub-header.component';
import { CheckinReviewSubHeaderComponent } from './sub-header/checkin-review-sub-header/checkin-review-sub-header.component';
import { CheckinSeatmapSubHeaderComponent } from './sub-header/checkin-seatmap-sub-header/checkin-seatmap-sub-header.component';
import { CheckinWaitingNumberSubHeaderComponent } from './sub-header/checkin-waiting-number-sub-header/checkin-waiting-number-sub-header.component';
import { CheckinStandbyReviewSubHeaderComponent } from './sub-header/checkin-standby-review-sub-header/checkin-standby-review-sub-header.component';
import { CheckinStandbyCompletedSubHeaderComponent } from './sub-header/checkin-standby-completed-sub-header/checkin-standby-completed-sub-header.component';
import { AswMasterService } from '@lib/services';
import { LOAD_MASTER_LIST } from '@conf';
import { lastValueFrom } from 'rxjs';
import { CheckinWaitingSearchSubHeaderComponent } from './sub-header/checkin-waiting-search-sub-header/checkin-waiting-search-sub-header.component';
import { MOffice } from '@lib/interfaces';
import { CheckinStandbyFlightAvailabilitySubHeaderComponent } from './sub-header/checkin-standby-flight-availability-sub-header/checkin-standby-flight-availability-sub-header.component';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'asw-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy, AfterViewInit {
  /**
   * ローディング画面表示制御 - 表示モード
   */
  public isPromotion$!: Observable<boolean>;
  /**
   * ローディング画面表示制御 - プロモーションモード判定フラグ
   */
  public isLoading$!: Observable<boolean>;

  constructor(
    private _aswCommonStoreService: AswCommonStoreService,
    private _aswContextStoreSvc: AswContextStoreService,
    private _translateSvc: TranslateService,
    private _errorHandlerSvc: ErrorsHandlerService,
    private _systemDateSvc: SystemDateService,
    private _loadingSvc: PageLoadingService,
    private _aswMasterService: AswMasterService,
    private router: Router,
    @Inject(NgZone) private _ngZone: NgZone,
    @Inject(DOCUMENT) private _document: Document
  ) {
    // ローディング画面の表示モードがプロモーションモードかの判定結果を取得
    this.isPromotion$ = this._loadingSvc.getIsPromotionMode$();
    // ローディング画面のローディング状態取得
    this.isLoading$ = this._loadingSvc.getPageLoadingState$();
  }

  // 言語（変更前の比較用）
  private lang = '';

  ngOnInit(): void {
    // エラーハンドリングServiceの初期化
    this._errorHandlerSvc.init();

    // システム日付Serviceの初期化
    this._systemDateSvc.init();

    //サブヘッダーを指定
    this.subPageSubscription = this._aswCommonStoreService.getPagefuncId$('page').subscribe((data) => {
      // NOTE: 各業務画面で必要なサブヘッダーを追加
      const funcPageId = (data.functionId ? data.functionId : '') + '-' + (data.pageId ? data.pageId : '');
      switch (funcPageId) {
        case CheckinFunctionIdType.CHECKIN + '-' + CheckinPageIdType.CHECKIN_SEARCH:
          this.subHeader = CheckinSearchSubHeaderComponent;
          break;
        case CheckinFunctionIdType.BOARDING_PROCEDURES + '-' + CheckinPageIdType.CHECKIN_MYBOOKING:
          this.subHeader = CheckinMybookingSubHeaderComponent;
          break;
        case CheckinFunctionIdType.BOARDING_PROCEDURES + '-' + CheckinPageIdType.CHECKIN_STANDBY_FLIGHT_AVAILABILITY:
          this.subHeader = CheckinStandbyFlightAvailabilitySubHeaderComponent;
          break;
        case CheckinFunctionIdType.BOARDING_PROCEDURES + '-' + CheckinPageIdType.CHECKIN_STANDBY_REVIEW:
          this.subHeader = CheckinStandbyReviewSubHeaderComponent;
          break;
        case CheckinFunctionIdType.BOARDING_PROCEDURES + '-' + CheckinPageIdType.CHECKIN_STANDBY_COMPLETED:
          this.subHeader = CheckinStandbyCompletedSubHeaderComponent;
          break;
        case CheckinFunctionIdType.CHECKIN + '-' + CheckinPageIdType.CHECKIN_SELECT:
          this.subHeader = CheckinSelectSubHeaderComponent;
          break;
        case CheckinFunctionIdType.CHECKIN + '-' + CheckinPageIdType.CHECKIN_PASSENGER_INPUT:
          this.subHeader = CheckinPassengerInputSubHeaderComponent;
          break;
        case CheckinFunctionIdType.CHECKIN + '-' + CheckinPageIdType.CHECKIN_REVIEW:
          this.subHeader = CheckinReviewSubHeaderComponent;
          break;
        case CheckinFunctionIdType.CHECKIN + '-' + CheckinPageIdType.CHECKIN_COMPLETED:
          this.subHeader = CheckinCompletedSubHeaderComponent;
          break;
        case CheckinFunctionIdType.CHECKIN + '-' + CheckinPageIdType.CHECKIN_SEATMAP:
          this.subHeader = CheckinSeatmapSubHeaderComponent;
          break;
        case CheckinFunctionIdType.NUMBER_OF_WAITING_CONFIRMATION + '-' + CheckinPageIdType.CHECKIN_WAITING_NUMBER:
          this.subHeader = CheckinWaitingNumberSubHeaderComponent;
          break;
        case CheckinFunctionIdType.NUMBER_OF_WAITING_CONFIRMATION + '-' + CheckinPageIdType.CHECKIN_WAITING_SEARCH:
          this.subHeader = CheckinWaitingSearchSubHeaderComponent;
          break;
        default:
          this.subHeader = SampleSubHeaderComponent;
          break;
      }
    });

    // 言語が変更された際にキャッシュをロードする。
    this._aswContextStoreSvc.getAswContext$().subscribe((data) => {
      if (data.lang && this.lang && data.lang !== this.lang) {
        // 利用言語の再設定とキャッシュ再ロード
        this._setLangAndloadCache(data.lang);
      }
      this.lang = data.lang;
    });

    this.routerSubscription = this.router.events.subscribe((event) => {
      //計測タグスクリプトの画面遷移時の処理を実行
      if (event instanceof NavigationEnd && (window as any).trackingTags?.onPageTransition !== undefined) {
        const url = event.urlAfterRedirects;
        const title = document.title;
        (window as any).trackingTags.onPageTransition(url, title);
      }
    });
  }

  /** 利用言語の設定とキャッシュ再ロード */
  private _setLangAndloadCache(langValue?: string) {
    let lang = langValue;
    if (lang) {
      lang = lang in I18N_CONFIG.supportedLocales ? lang : 'ja';
    } else {
      lang = I18N_CONFIG.defaultLanguage;
    }
    this._translateSvc
      .use(lang)
      .pipe(take(1))
      .subscribe(() => {
        // キャッシュ再ロード
        lastValueFrom(this._aswMasterService.load(LOAD_MASTER_LIST));
      });
    // html lang属性再設定
    this._document.documentElement.lang = I18N_CONFIG.supportedLocales[lang];
  }

  ngOnDestroy(): void {
    if (this.subPageSubscription) {
      this.subPageSubscription.unsubscribe();
    }

    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  ngAfterViewInit() {
    this._ngZone.runOutsideAngular(() => {
      this._setDynatraceTag();
    });
  }

  /**
   * Dynatrace用scriptタグを設置
   */
  private _setDynatraceTag() {
    let key: 'res' | 'srv' | 'exc' | 'cki';
    const URL = window.location.href;
    switch (true) {
      case URL.includes(`${environment.spa.baseUrl}${environment.spa.app.res}`):
        key = 'res';
        break;
      case URL.includes(`${environment.spa.baseUrl}${environment.spa.app.srv}`):
        key = 'srv';
        break;
      case URL.includes(`${environment.spa.baseUrl}${environment.spa.app.exc}`):
        key = 'exc';
        break;
      case URL.includes(`${environment.spa.baseUrl}${environment.spa.app.cki}`):
        key = 'cki';
        break;
      default:
        return;
    }

    if (environment.dynatrace[key].disable || !environment.dynatrace[key].url) {
      return;
    }

    const $script: HTMLScriptElement = this._document.createElement('script');
    $script.async = true;
    $script.type = 'text/javascript';
    $script.src = environment.dynatrace[key].url;
    $script.crossOrigin = 'anonymous';
    const $head: HTMLHeadElement = this._document.getElementsByTagName('head')[0];
    if ($head) {
      $head.appendChild($script);
    }
  }

  subPageSubscription?: Subscription;
  public subHeader: any;

  routerSubscription?: Subscription;
}
